import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import AccountSumUtils from "../../../UtilComponents/AccountSumUtils";
import TradeUtil from "../../../UtilComponents/TradeUtil";
import ManualTradeSwitcher from "./ManualTradeSwitcher";

export default function UDManualtradeUI({ pathname }) {
	return (
		<Box
			sx={{
				py: 4,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				textAlign: "center",
				width: "90%",
				my: "1rem",
			}}>
			<ManualTradeSwitcher />
			{/* <TradeUtil /> */}
		</Box>
	);
}

UDManualtradeUI.propTypes = {
	pathname: PropTypes.string.isRequired,
};
